import i18next from 'i18next';
import Swal from 'sweetalert2';

async function excluirAlert({ opcoes = {}, confirmar = () => {}, cancelar = () => {} }) {
  const locale = await i18next.getResourceBundle(i18next.language, 'services/alerts');

  const result = await Swal.fire({
    reverseButtons: true,
    title: locale.excluirAlert.titulo,
    text: '',
    icon: 'warning',
    showCancelButton: true,
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: locale.acoes.confirmar,
    cancelButtonText: locale.acoes.cancelar,
    ...opcoes,
  });
  if (result.value) {
    confirmar(result);
  } else {
    cancelar(result);
  }
}

export default excluirAlert;
